import React from 'react';
import PropTypes from 'prop-types';
import { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { postAppointment, putAppointment } from '../../store/actions/appointments/appointments_action';
import { API_PREFIX as API, API_ROUTES } from '../../constants/api_routes';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        width: '100%'
    }
});

const showErrorsAndMessages = (violations, enqueueSnackbar, setError, successMessage) => {
    if (!violations) {
        enqueueSnackbar(successMessage, { variant: 'success' });
        return;
    }
    for (const violation of violations) {
        enqueueSnackbar(violation?.message, { variant: 'warning' });
        if (violation?.propertyPath) {
            setError(violation?.propertyPath, { message: violation?.message });
        }
    }
}

const CommandLayout = ({ defaultProps, getAppointments  }) => {
    const { onCommitButtonClick } = defaultProps;
    const { root } = useStyles();
    const dispatch = useDispatch();
    const { handleSubmit, setError, formState: { errors } } = useFormContext();
    const { enqueueSnackbar } = useSnackbar();

    const onSubmit = async (data) => {
        data.article = data.article?.['@id'] || `${API}${API_ROUTES.ARTICLES}/${data?.article?.uuid}`;
        data.customer = data.customer ? (data.customer?.['@id'] || `${API}${API_ROUTES.CUSTOMERS}/${data?.customer?.uuid}`) : null;
        data.worker = data.worker ? (data.worker?.['@id'] || `${API}${API_ROUTES.WORKERS}/${data?.worker?.uuid}`) : null;
        data.technician = data.technician ? (data.technician?.['@id'] || `${API}${API_ROUTES.WORKERS}/${data?.technician?.uuid}`) : null;
        data.insuranceCompany = data.insuranceCompany ? (data.insuranceCompany?.['@id'] || `${API}${API_ROUTES.WORKERS}/${data?.insuranceCompany?.uuid}`) : null;
        data.place = data.place ? (data.place?.['@id'] || `${API}${API_ROUTES.PLACES}/${data?.place?.uuid}`) : null;
        data.uuid = data?.id;
        const { violations } = data.id ? await dispatch(putAppointment(data)) : await dispatch(postAppointment(data));
        const successMessage = data.id ? 'Uspešno izmenjen termin' : 'Uspešno unet termin';
        showErrorsAndMessages(violations, enqueueSnackbar, setError, successMessage);
        if (!Object.keys(errors).length && !violations) {
            onCommitButtonClick();
            getAppointments();
        }
    }

	return <AppointmentForm.CommandLayout className={root} {...defaultProps} disableSaveButton={false} onCommitButtonClick={handleSubmit(onSubmit)} />
};

CommandLayout.propTypes = {
    defaultProps: PropTypes.object,
    getAppointments: PropTypes.func
}

export default CommandLayout;
